import { useContext, useEffect, useState } from "react"
import MediaQuery from "react-responsive";
import ConsumosLayout from "../../layouts/Consumos/ConsumosLayout";
import ConsumosTablet from "./ConsumosTablet";
import ConsumosDesktop from "./ConsumosDesktop";
import useTranslation from "../../hooks/useTranslation";
import { DialogoSeleccionarCaja } from "./components/DialogoSeleccionarCaja";
import { ConsumosHeader } from "./components/ConsumosHeader";
import AppBar from "../../components/app-bar";
import { SnackbarContext } from "@gti-controls-v2/web-core";
import apiConfig from "../../config/api";
import { AuthContext } from "../../providers/auth";
import { DialogoSesionFinalizo } from "./components/DialogoSesionFinalizo";
import { DialogoHacerCorte } from "./components/DialogoHacerCorte";
import { localStorageData } from "../../common/constants/Settings";

export const Consumos = () => {
    /** Estado de la forma */
    const { user } = useContext(AuthContext);
    const { t } = useTranslation();
    const { useSnackbar } = useContext(SnackbarContext);
    const { enqueueSnackbar } = useSnackbar();
    const anchorOrigin = { vertical: "bottom", horizontal: "right" };

    const [consumos, setConsumos] = useState([]);
    const [cajas, setCajas] = useState(null);
    const [corte, setCorte] = useState();
    const [corteFecha, setCorteFecha] = useState();
    const [corteLastID, setCorteLastID] = useState();
    const [cortes, setCortes] = useState([]);
    const [consumosTotal, setConsumosTotal] = useState("");
    const [caja, setCaja] = useState(0);
    const [cajaNombre, setCajaNombre] = useState();
    const [cajaOpen, setCajaOpen] = useState(false);
    const [sesionFinalizo, setSesionFinalizo] = useState(false);
    const [dialogoHacerCorteOpen, setDialogoHacerCorteOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {

        const getData = async () => {
            try {
                setLoading(true);

                //Cuando la fecha futura del token sea menor a la fecha actual, se finaliza la sesion
                if (new Date(user.token_expires_at) < new Date()) {
                    //Muestro dialogo modal de sesión finalizo
                    setSesionFinalizo(true);
                    //Borro el intervalo para que no se siga ejecutando cada 5 seg.
                    clearInterval(intervalId);
                }
                else {//Cuando la fecha de vencimiento esta vigente, sigo cargando los consumos.
                    //Obtengo el listado de cajas para el usuario
                    if (cajas == null) {
                        const result = await getCajas();
                        setCajas(result);

                        //Solo si hay cajas muestro dialogo para seleccionar la caja//Solo si hay cajas muestro dialogo para seleccionar la caja. Solo > 1 porque siempre agrego un registro con ID = 0
                        if (parseInt(result.length) > 1) {
                            //Obtengo el dato de cajaID en localStorage
                            const cajaIDLocalStorage = parseInt(localStorage.getItem(localStorageData.CAJA_ID));

                            //Si NO existe el dato de cajaID en localStorage o es < 0, muestro el dialogo para seleciconar caja
                            if (!cajaIDLocalStorage || cajaIDLocalStorage <= 0) {
                                setCajaOpen(true);
                            } else {
                                //Si existe el dato de cajaID en localStorage y es > 0, obtengo el nombre de la caja
                                const cajaNombreLocalStorage = getCajaNombre(cajaIDLocalStorage, result);
                                //Si la cajaID se encuetra en el listado de cajas, asigno las variables de estado
                                if (cajaNombreLocalStorage) {
                                    setCaja(cajaIDLocalStorage);
                                    setCajaNombre(getCajaNombre(cajaIDLocalStorage, result));
                                }
                                else {
                                    //Si la cajaID no se encuentra en el listado de cajas, muestro el dialogo para seleciconar caja
                                    setCajaOpen(true);
                                }
                            }
                        }
                    }
                    //Si la caja seleccionada es >= 0, puedo obtener los consumos.
                    if (caja > 0) {
                        await refreshConsumos();
                    }
                }
            } catch (err) {
                setError(err.message);
                console.error('Error al obtener los datos:', err);
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        // Fetch data immediately when component mounts
        getData();

        // Set up interval to fetch data every 10 seconds
        const intervalId = setInterval(getData, 10000);

        // Clear interval when component unmounts
        return () => clearInterval(intervalId);

        // eslint-disable-next-line
    }, [caja, cajas])

    /** Función que obtiene el listado de consumos */
    const refreshConsumos = async () => {
        try {
            setLoading(true);
            const corteUltimo = await getCorteUltimo(caja);
            setCorte(corteUltimo.CorteID);
            setCorteFecha(corteUltimo.CorteFecha);
            setCorteLastID(corteUltimo.LastID);

            const cortesCount = await getCortesCount(corteUltimo.CorteID);
            setCortes(cortesCount);

            const result = await getConsumos(corteUltimo.CorteID, corteUltimo.CorteFecha, corteUltimo.LastID);
            setConsumos(result);
        } catch (err) {
            console.error('Error refreshing consumos:', err);
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    }

    /** Función que obtiene el listado de consumos
     * @param {corteID} - identificador del ultimo corte de la caja seleccionada, que devuele la petición getCorteUltimo.
     * @param {corteFecha} identificador de la fecha para ultimo corte de la caja seleccionada, que devuele la petición getCorteUltimo.
     * @param {lastID} identificador LastID para ultimo corte de la caja seleccionada, que devuele la petición getCorteUltimo.
     */
    const getConsumos = async (corteID, corteFecha, lastID) => {
        const response = await fetchConsumos(corteID, corteFecha, lastID);

        if (!response.ok) {
            throw new Error(
                `This is an HTTP error: The status is ${response.status}`
            );
        }

        let actualData = await response.json();
        let array = [];
        for (const item of actualData) {
            array.push(
                {
                    CafeDocID: item.CafeDocID,
                    Foto: item.Foto,
                    EmpNumero: item.EmpNumero,
                    PersonaName: item.PersonaName,
                    PuestoNombre: item.PuestoNombre,
                    CafeProdNombre: item.CafeProdNombre,
                    CafeDocStamp: item.CafeDocStamp
                }
            );
        }

        setError(null);

        return array;
    }

    /** Función que obtiene el listado de cajas a los cuales tiene acceso el usaurio */
    const getCajas = async () => {
        const response = await fetchCajas();

        if (!response.ok) {
            throw new Error(
                `This is an HTTP error: The status is ${response.status}`
            );
        }

        let actualData = await response.json();
        let array = [{ CafeCajaID: 0, CafeCajaNombre: t("sistema.acciones.seleccionaValor") }];
        if (actualData) {
            for (const item of actualData) {
                array.push(
                    {
                        CafeCajaID: item.CafeCajaID,
                        CafeCajaNombre: item.CafeCajaNombre,
                    }
                );
            }
        }

        setError(null);
        
        return array;
    }

    /** Función que obtiene el nombre de una caja */
    const getCajaNombre = (cajaID, cajas) => {
        if (cajas?.length) {
            for (const item of cajas) {
                if (item.CafeCajaID === cajaID) {
                    if (item.CafeCajaID > 0) {
                        return item.CafeCajaNombre;
                    }
                    else {
                        return "";
                    }
                }
            }
        }
    };

    /** Función que obtiene el ultimo corte de la caja seleccionada 
     * @param {cajaID} - identificador de la caja seleccionada.
    */
    const getCorteUltimo = async (cajaID) => {
        const response = await fetchCorteUltimo(cajaID);

        if (!response.ok) {
            throw new Error(
                `This is an HTTP error: The status is ${response.status}`
            );
        }

        let actualData = await response.json();

        setError(null);

        return actualData;
    }

    /** Función que obtiene los totales de consumos por tipo, y calcula el total
     * @param {corteID} - identificador del corte.
     */
    const getCortesCount = async (corteID) => {
        const response = await fetchCortesCount(corteID);

        if (!response.ok) {
            throw new Error(
                `This is an HTTP error: The status is ${response.status}`
            );
        }

        let actualData = await response.json();

        let sum = 0;
        for (const item of actualData) {
            sum += item.Conteo;
        }
        setConsumosTotal(sum);

        setError(null);

        return actualData;
    }

    /** Función que hace la petición al servidor para obtener el listado de consumos
     * @param {corteID} - identificador del ultimo corte de la caja seleccionada, que devuele la petición getCorteUltimo.
     * @param {corteFecha} identificador de la fecha para ultimo corte de la caja seleccionada, que devuele la petición getCorteUltimo.
     * @param {lastID} identificador LastID para ultimo corte de la caja seleccionada, que devuele la petición getCorteUltimo.
     */
    const fetchConsumos = async (corteID, corteFecha, lastID) => {
        const body = {
            corteID: corteID,
            CorteFecha: corteFecha,
            LastID: lastID
        };

        const response = await fetch(apiConfig.API_URL_CONSUMOS, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token,
                'gti_clienteID': user.clienteID,
            },
            body: JSON.stringify(body)
        })

        return (response);
    }

    /** Función que hace la petición al servidor para obtener el listado de cajas a los cuales tiene acceso el usaurio */
    const fetchCajas = async () => {
        const response = await fetch(apiConfig.API_URL_CAJAS, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token,
                'gti_clienteID': user.clienteID
            },
        });

        return (response);
    }

    /** Función que hace la petición al servidor para obtener ultimo corte de la caja seleccionada 
     * @param {cajaID} - identificador de la caja seleccionada.
    */
    const fetchCorteUltimo = async (cajaID) => {
        const response = await fetch(apiConfig.API_URL_CORTES_ULTIMO.replace("{cajaID}", cajaID), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token,
                'gti_clienteID': user.clienteID
            },
        });

        return (response);
    }
    /** Función que hace la petición al servidor para obtener los totales de consumos por tipo
     * @param {corteID} - identificador del corte.
     */
    const fetchCortesCount = async (corteID) => {
        const response = await fetch(apiConfig.API_URL_CORTES_COUNT.replace("{corteID}", corteID), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token,
                'gti_clienteID': user.clienteID
            },
        });

        return (response);
    }
    /** Función que realiza un corte */
    const hacerCorte = async () => {
        try {
            setLoading(true);
            setDialogoHacerCorteOpen(true);
        } catch (err) {
            console.error('Error al hacer corte:', err);
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    }
    /** Función que realiza un corte */
    const ejecutarCorte = async () => {
        try {
            setLoading(true);
            const response = await postCorte(corte, corteFecha, corteLastID);

            if (!response.ok) {
                throw new Error(
                    `This is an HTTP error: The status is ${response.status}`
                );
            }

            let actualData = await response.json();

            await refreshConsumos();

            enqueueSnackbar(
                t("sistema.acciones.hicisteCorte"),
                {
                    variant: "success",
                    anchorOrigin,
                }
            );

            setError(null);

            return actualData;
        } catch (err) {
            console.error('Error al ejecutar corte:', err);
            setError(err.message);
        }
        finally {
            setLoading(false);
        }
    }
    /** Función que hace la petición al servidor para hacer un corte 
     * @param {corteID} - identificador del ultimo corte de la caja seleccionada.
     * @param {corteFecha} identificador de la fecha para ultimo corte de la caja seleccionada.
     * @param {lastID} identificador LastID para ultimo corte de la caja seleccionada.
     */
    const postCorte = async (corteID, corteFecha, lastID) => {
        const body = {
            CorteID: corteID,
            CorteFecha: corteFecha,
            LastID: lastID
        };

        const response = await fetch(apiConfig.API_URL_CORTE, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.token,
                'gti_clienteID': user.clienteID
            },
            body: JSON.stringify(body)
        });

        return (response);
    }

    return (
        <ConsumosLayout>
            <AppBar cajaNombre={cajaNombre} setCajaOpen={setCajaOpen} />

            <DialogoSesionFinalizo
                sesionFinalizo={sesionFinalizo} />

            <DialogoSeleccionarCaja
                setCaja={setCaja}
                setCajaNombre={setCajaNombre}
                cajaOpen={cajaOpen}
                setCajaOpen={setCajaOpen}
                loading={loading}
                cajas={cajas} />

            <DialogoHacerCorte
                dialogoHacerCorteOpen={dialogoHacerCorteOpen}
                setDialogoHacerCorteOpen={setDialogoHacerCorteOpen}
                ejecutarCorte={ejecutarCorte} />

            <ConsumosHeader
                corte={corte}
                corteFecha={corteFecha}
                consumosTotal={consumosTotal} />

            <MediaQuery maxWidth={1024}>
                <ConsumosTablet
                    consumos={consumos}
                    refreshConsumos={refreshConsumos}
                    loading={loading}
                    cortes={cortes}
                    hacerCorte={hacerCorte} />
            </MediaQuery>

            <MediaQuery minWidth={1024.1}>
                <ConsumosDesktop
                    consumos={consumos}
                    refreshConsumos={refreshConsumos}
                    loading={loading}
                    cortes={cortes}
                    hacerCorte={hacerCorte} />
            </MediaQuery>

        </ConsumosLayout>
    );
};

export default Consumos;
